import PropTypes from "prop-types"
import React from "react"
import NavBar from "./navbar"
import { useLocation } from "@reach/router"
import { useTranslation } from "react-i18next"
import Languages from "./languages"

const Header = ({ menuLinks }) => {
  const { t } = useTranslation()
  const location = useLocation()

  const locationName = location.pathname.replace(/\/([a-z]{2})\/|\//g, "")

  const pageName = menuLinks.filter(({ link }) =>
    link.includes(locationName)
  )[0]?.name

  return (
    <header>
      <h3 className="page__title">
        {!pageName
          ? 404
          : pageName === "Home"
          ? "Correo Saliente"
          : t(pageName + ".name")}
      </h3>
      <NavBar menuLinks={menuLinks} locationName={locationName} />
      <Languages />
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
